import type { Card, PriceHistory } from '@/types'
import { request } from './client'

export async function getAllCards(): Promise<{ cards: Card[]; updatedAt: string }> {
  return request<{ cards: Card[]; updatedAt: string }>('/cards/all')
}

export async function getCard(id: number): Promise<{ card: Card }> {
  return request<{ card: Card }>(`/cards/${id}`)
}

export async function getCardPriceHistory(
  id: number,
  days: number = 30,
): Promise<{
  cardId: number
  name: string
  prices: PriceHistory[]
}> {
  return request(`/cards/${id}/prices?days=${days}`)
}
